import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

import {AddCensusService} from '../../../../shared/services/nso-data-portal/add-services/add-census-service';
import {FormHelperService} from '../../../../shared/services/person/form-helper-service';
import * as _ from 'lodash';
import {SelectItem} from 'primeng/api';
import * as moment from 'moment';
import {CensusesData} from '../../../../shared/types/nso-data-portal/census-data';
import {checkDateValidation} from './add-census.validations';

const CENSUS_STARTING_YEAR = 2019;
const CENSUS_FUTURE_YEARS_COUNT = 20;

@Component({
  selector: 'wsd-add-census',
  templateUrl: './add-census.component.html',
  styleUrls: ['./add-census.component.css']
})
export class AddCensusComponent implements OnInit {

  @Output()
  onSave = new EventEmitter<any>();

  @Input()
  censuses: CensusesData[];

  census: CensusesData;

  censusForm: UntypedFormGroup;

  display = false;

  years: SelectItem[];

  constructor(private addCensusService: AddCensusService,
              private formHelper: FormHelperService,
              private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.censusForm = this.fb.group({
      year: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required]
    }, {validators: checkDateValidation.bind(this)});
    this.addCensusService.messageSent$.subscribe(
      (census: CensusesData) => {
        this.years = this.initYears();
        if (census.year) {
          this.years.unshift({label: census.year.toString(), value: census.year});
        }
        this.census = census;
        this.censusForm.reset();
        this.censusForm.patchValue(census);
        this.display = true;
      }
    );
  }

  initYears() {
    const existingYears = this.censuses
      .map(entry => entry.year);

    return [{label: '', value: ''}].concat(
      // @ts-ignore
      _.range(CENSUS_STARTING_YEAR, moment().year() + CENSUS_FUTURE_YEARS_COUNT).map(
        year => {
          return !existingYears.includes(year) && {label: year, value: year};
        }
      ).filter(Boolean)
    );
  }

  save() {
    this.formHelper.validateAllFormFields(this.censusForm);
    if (this.censusForm.invalid) {
      return;
    }
    _.assign(this.census, this.censusForm.value);
    this.display = false;
    this.onSave.emit(this.census);
  }

}
